import { Component, Vue, Watch } from 'vue-property-decorator'
import { lineChart } from '../../../../components/charts/index'
import { lineChartData, lineChartOptions } from './chartConfig'
import { mapState } from 'vuex';
import { ISession, IChartDatasetes, IChartSettings } from '@/types'

@Component({
  components: {
    lineChart
  },
  computed: mapState({
    ServiceId: (state: { session: ISession }) => state.session.serviceId
  })
})

export default class Competitors extends Vue {

  private namespace: string = '/Keywords';

  private ServiceId!: number;

  private competitors: {
    domainName: string, 
    keywordsDetails: {
      keyword: string,
      searchVolume: number,
      dates: string[],
      competitors: {
        domain: string,
        currentPlace: number,
        rankings: number[],
      }[],
      domain: string,
      currentPlace: number,
      rankings: number[]
    }[]} | null = null;

  private keyword: number = 0;

  private error: boolean = false;

  private get Competitors() {

    if (this.competitors != null) {
  
      const competitors = this.competitors.keywordsDetails[this.keyword].competitors,
      maxCompetitors = competitors.filter((competitor: any, index: number) => index < 2);
      console.log('HEJ', maxCompetitors)
      return maxCompetitors;
    }

    return null;
  }

  private get LineChartData () {

    const chartData: IChartSettings = {
      labels: [],
      datasets: [],
    };

    const datasets: IChartDatasetes[] = [];

    const datasetVals = {...lineChartData};

    if (this.competitors != null && (this.Competitors != null && this.Competitors.length > 0)) {
      
      const competitors = [...this.Competitors],
            themes = ['#f075a2', '#6aa8e4', '#ff8363'];
      
      competitors.unshift(this.competitors.keywordsDetails[this.keyword]);

      competitors.forEach((competitor: { domain: string, currentPlace: number, rankings: (number | null)[] }, i: number) => {

        let competitorsData = { ...datasetVals };

        competitorsData.label = competitor.domain;
        competitorsData.backgroundColor = themes[i];
        competitorsData.borderColor = themes[i];
        competitorsData.pointBorderColor = themes[i];
        competitorsData.pointHoverBackgroundColor = themes[i];
        competitorsData.pointHoverBorderColor = themes[i];
        competitorsData.data = competitor.rankings.map(val => 
          val != 0 ? val : null
        );

        datasets.push(competitorsData);
      });
      
      
      chartData.labels = this.competitors.keywordsDetails[this.keyword].dates;
      chartData.datasets = datasets;
    }

    return chartData;
  }

  private get LineChartOptions () {

    if (this.competitors != null) {

      let chartOptions = {...lineChartOptions};

      chartOptions.scales.yAxes[0].scaleLabel.labelString = this.$t('keywords.rankings.title') as string;

      return chartOptions;
    }

    return lineChartOptions;
  }

  beforeMount() {

    if (this.ServiceId) {

      return this.getData();
    }
  }

  private selectKeyword(index: number) {

    this.keyword = index;
  }

  private async getData() {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/Competitors`, {
        params: {
          serviceId: this.ServiceId
        }
      });

      this.competitors = response.data;

    } catch (err) {

      this.error = !this.error;
    }
  }

  @Watch('ServiceId')
  private loadDomain (next: number, prev: number) {

    if (next != prev) {
    
      this.competitors = null;
      this.getData();
    }
  }
}